/*
 * wbePlus
 */
function factory({ window, document, thn }) {

  const engine = {};

  engine._wbeOpened = function () {

    const el = document.getElementById('wbe_overlay');

    return (el && el.attributes['aria-hidden'] && el.attributes['aria-hidden'].value !== 'true');
  };

  engine._wbeData = function () {

    let result;
    const hotelId = window.wbeCurrentHotel;
    const sessionVarName = `wbe-hotel-${hotelId}`;
    const sessionVar = window.sessionStorage && window.sessionStorage.getItem(sessionVarName);

    if (sessionVar) {
      try {
        result = JSON.parse(sessionVar);
      } catch (err) {
        this.logger.warn(`Can't get BE data: sessionStorage variable ${sessionVarName} is not a JSON!`);
      }
    } else {
      this.logger.warn(`Can't get BE data: sessionStorage variable ${sessionVarName} not found!`);
    }

    return result;
  };

  /**
     * @memberOf module:bs_112
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {
    // Detect language changes in BE by the click in the country flags
    const undelegate = thn.delegate('click', '.wbe-infoBox-langs img', function () {
      setTimeout(thn.languageCheck, 400);
    });

    thn.shutdown(function () {
      undelegate();
      delete thn.data.wbeLastHash;
    });

    const closeBtnUndelegate = thn.delegate('click', '.wbe_overlay_close', function () {
      setTimeout(thn.pageCheck, 400);
    });

    thn.shutdown(function () {
      closeBtnUndelegate();
    });

  };

  /**
     * @memberOf module:bs_112
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    if (thn.data.wbeLastHash !== window.location.hash) {
      // If we change between homepage and BE, we need to reload the language
      thn.languageCheck();

      // And we need to reload the page too
      setTimeout(function () {
        const formerPage = thn.data.pageName;

        thn.pageCheck();

        // Reset PW if we came from another page
        if (formerPage !== thn.data.pageName && thn.data.pageName === 'Rooms and Rates') {
          thn.widgets.price.reset();
        }
      }, 400);

      thn.data.wbeLastHash = window.location.hash;
    }
  };

  engine.onHashChange = function onHashChange(ctx) {
    setTimeout(thn.pageCheck, 500);
  };

  /**
     * @memberOf module:bs_112
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {
      thn.domReady().then(function () {
        let aux;

        if (engine._wbeOpened()) { // Language of the BE
          const beData = engine._wbeData();

          if (beData && beData.settings && beData.settings.lang && ctx.langs.test(beData.settings.lang)) {
            resolve(beData.settings.lang);
            return;
          }
        } else { // Language of the page
          aux = (thn.parseUrlParameter('lang')
                        || ctx.getHtmlLang()
                        || ((aux = window.location.pathname.match(/\/(\w{2})(\/|$)/i)) && aux.length >= 2 && aux[1])
                        || ((aux = window.location.hostname.match(/\/\/(\w{2})\./i)) && aux.length >= 3 && aux[2])
                        || '').substr(0, 2);
          if (aux && ctx.langs.test(aux)) {
            resolve(aux);
            return;
          }
        }

        reject('no_language');
      });
    });
  };

  engine.priceObserveDom = function priceObserveDom(ctx) {

    const roomContainer = document.querySelector('.wbe-room-firstView:last-child');

    if (roomContainer && !thn.wbeRnrUpdater) {
      thn.wbeRnrUpdater = thn.debounce(function thnWbeRnrUpdater() {
        // Try to refresh PW
        ctx.widget.refresh();
        if (!ctx.widget.isSet()) {
          ctx.widget.hide();
        }
      }, 1000);

      // Start observation
      thn.observeDom(roomContainer, thn.wbeRnrUpdater, {
        childList: true,
        subtree: true,
        characterData: false,
        attributes: false,
      });

      // Stop the observation on page unload
      thn.pageUnload(function () {
        thn.stopObserveDom(roomContainer, thn.wbeRnrUpdater);

        delete thn.wbeRnrUpdater;
      });
    }
  };

  engine.priceParseData = function priceParseData(ctx) {

    var widgetData = {};

    const beData = engine._wbeData();
    if (beData) {
      // Default values
      widgetData.rooms = 1;
      widgetData.adults = 1;
      widgetData.children = 0;

      // Room details
      if (beData.roomconfig && beData.roomconfig.length) {
        // Dates
        widgetData.dateBegin = thn.dateToString(beData.roomconfig[0].arrival);
        widgetData.dateEnd = thn.dateToString(beData.roomconfig[0].depart);

        // Rooms
        widgetData.rooms = beData.roomconfig.length;

        widgetData.adults = parseInt(beData.roomconfig[0].adults, 10) || 0;
        widgetData.children = parseInt(beData.roomconfig[0].childs, 10) || 0;
      }

      // Guests
      widgetData.guests = widgetData.adults + widgetData.children;

      // Prices
      const prices = Array.from(document.querySelectorAll('.wbe-roomList-title-price')).map(function (el) {
        return thn.parseNumber((el.textContent || '').replace(/'/g, ''));
      }).filter(Boolean);

      const auxCurrency = beData.settings ? thn.getCurrencyCode(beData.settings.currency) : '';

      // Price per night // Currency
      if (auxCurrency && !thn.empty(prices) && widgetData.dateBegin && widgetData.dateEnd) {

        widgetData.currency = auxCurrency;
        widgetData.price = Math.round((Math.min(...prices) / thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd)) * 100) / 100;
        widgetData.set = true;
      } else if (document.querySelector('.wbe-noAvailRooms')
                // Property 1033470 doesn't always show the unavailability selector because it has rooms on request
                || ([1033470].includes(thn.data.propertyId) && thn.empty(prices))) {
        widgetData.noRooms = true;
      }
    }

    return widgetData;
  };

  engine.bookingParseData = function bookingParseData(ctx) {

    var widgetData = {};

    const beData = engine._wbeData();
    if (beData) {
      // Id
      widgetData.bookingId = beData.resid;

      // Dates
      widgetData.dateBegin = thn.dateToString(beData.roomconfig[0].arrival);
      widgetData.dateEnd = thn.dateToString(beData.roomconfig[0].depart);

      // Currency
      widgetData.currency = beData.settings && thn.getCurrencyCode(beData.settings.currency);
      // Total
      widgetData.price = beData.summary && beData.summary.total;
    }

    return widgetData;
  };

  return engine;

}

export { factory };
